import { render, staticRenderFns } from "./lottery-kind.vue?vue&type=template&id=47d64c5e&"
import script from "./lottery-kind.vue?vue&type=script&lang=js&"
export * from "./lottery-kind.vue?vue&type=script&lang=js&"
import style0 from "./lottery-kind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports